export default __webpack_public_path__ + "static/media/filling_0.2013466f.webp";